import { CapacitorHttp } from '@capacitor/core'

export const obtainTikTokRedirectUrl = async (url: string): Promise<string> => {
  try {
    const response = await CapacitorHttp.get({ url })

    return response?.url || ''
  } catch (error) {
    console.error(error)
    return ''
  }
}
